export default {
  init() {

    $('.hamburger').click(function() {

      $(this).toggleClass('is-active');
      $('body').toggleClass('no-scroll');

      let mobileNavHeight = $('.sticky-header').height();

      if ($('#wpadminbar').length > 0) {
        mobileNavHeight += $('#wpadminbar').height();
      }

      $('.mobile-nav-menu').css('top', mobileNavHeight);
      $('.mobile-nav-menu').toggleClass('go');
    });

    // $('.sticky-header').waypoint(function(direction) {
    //   if(direction === "down"){
    //     $('.sticky-header').addClass('white-bg');
    //   } else {
    //     $('.sticky-header').removeClass('white-bg');
    //   }
    // }, {
    //   offset: '-20px',
    // })


    let currentLocation = 'all';
    let currentDeparment = 'all';

    function makeActive(myObj){
      $('.company-click, .team-click').removeClass('active');

      var targetCat = myObj.attr('data-filter');
      var filterType = myObj.attr('data-filter-type');

      if(filterType == "department"){
        currentDeparment = targetCat;
      } else {
        currentLocation = targetCat;
      }
      // check my targets


      if(targetCat === "alled")
      {
        $('.company-click, .team-click').addClass('active');
      }
      else
      {
        $('.company-click, .team-click').each(function(){

          var self = this;
          var filters = $(this).attr('data-groups').split(',');

          if( $('body').hasClass('tmpl-team') ) {
            var test = $(this).attr('data-departments').split(',');
          }


          var locMatch = false;
          var depMatch = false;

          if(currentLocation == 'all'){
              locMatch = true;
          } else {
            $.each(filters, function(index, value){
              if(value === currentLocation) {
                if(!locMatch) {
                  locMatch = true;
                }
              }
            });
          }

          if(currentDeparment == 'all'){
            depMatch = true;
          } else {
            $.each(test, function(index, value){
              value = $.trim(value);
              if(value === currentDeparment) {
                if(!depMatch) {
                  depMatch = true;
                }
              }
            });
          }


          if(locMatch & depMatch) {
            $(self).addClass('active');
          }

        });
      }


      $('.shuffle-container').removeClass('remove');
    }

    $('.filters li a').click(function(e){
      e.preventDefault();

      // Remove all active classes
      $('.shuffle-container').addClass('remove');
      var dataType = $(this).attr('data-filter-type');
      if(dataType == "department"){
        $('.department--filter li a').each(function(){
          $(this).removeClass('active');
        });
      } else {
        $('.location--filter li a').each(function(){
          $(this).removeClass('active')
        });
      }

      $('.portfolio-list li a').each(function(){
        $(this).removeClass('active');
      });


      $(this).addClass('active');

      var self = $(this)
      setTimeout(function(){
        makeActive(self);
      }, 500);

    });



    var currentCompany = null;

    $('.company-next').click(function(e){
      e.preventDefault();
      currentCompany.next().trigger('click');
    });

    $('.company-prev').click(function(e){
      e.preventDefault();
      currentCompany.prev().trigger('click');
    });


    $('.company-click').click(function() {
      $('.modal-main').addClass('change');
      currentCompany = $(this);

      $('.modal-container').addClass('show-modal');
      $('.modal-content').addClass('show-modal-content');
      $('body').addClass('no-scroll');

      // Comapany Modal Details
      var title = $(this).attr('data-title');
      var website = $(this).attr('data-website');
      var desc = $(this).attr('data-desc');
      var facts = $(this).attr('data-facts');
      var team = $(this).attr('data-team');
      var companyLogo = $(this).attr('data-logo');

      // Previous
      var prevTitle = $(this).prev().attr('data-title');
      var nextTitle = $(this).next().attr('data-title');


      setTimeout(function(){
        // clear out everything
        $('.modal-container .name h2').html("");
        $('.modal-container .name a').attr('href', "");
        $('.modal-container .content').html("");
        $('.modal-container .company-facts ul').html("");
        $('.modal-container .team-involved ul').html("");
        $('.modal-container .company-logo').attr('src', "");

        $('.modal-container .name h2').html(title);
        $('.modal-container .name a').attr('href', website);
        $('.modal-container .content').html(desc);
        $('.modal-container .company-facts ul').html(facts);

        if(team){
          $('.modal-container .team-involved').show();
          $('.modal-container .team-involved ul').html(team);
        } else {
          $('.modal-container .team-involved').hide();
        }
        $('.modal-container .company-logo').attr('src', companyLogo);

        // Prev Next
        if(!prevTitle){
          $('.left-meet').css('opacity', 0);
        } else {
          $('.left-meet').css('opacity', 1);
          $('.left-meet').html(prevTitle);
        }

        if(!nextTitle){
          $('.right-meet').css('opacity', 0);
        } else {
          $('.right-meet').css('opacity', 1);
          $('.right-meet').html(nextTitle);
        }

        $('.modal-main').removeClass('change');

      }, 600);


    });



    var currentTeam = null;


    $('.team-next').click(function(e){
      e.preventDefault();
      currentTeam.next().trigger('click');
    });

    $('.team-prev').click(function(e){
      e.preventDefault();
      currentTeam.prev().trigger('click');
    });

    $('.team-click').click(function() {
      $('.modal-main').addClass('change');
      currentTeam = $(this);

      $('.modal-container').addClass('show-modal');
      $('.modal-content').addClass('show-modal-content');
      $('body').addClass('no-scroll');


      // Comapany Modal Details
      var image = $(this).attr('data-profileImg');
      var title = $(this).attr('data-title');
      var bio = $(this).attr('data-bio');
      var related = $(this).attr('data-related');

      // Previous
      var prevTitle = $(this).prev().attr('data-title');
      var nextTitle = $(this).next().attr('data-title');


      setTimeout(function(){
        // // clear out everything
        $('.modal-container .name h2').html("");
        $('.modal-container .team-image img').attr('src', "");
        $('.modal-container .content').html("");
        $('.modal-container .involved ul').html("");
        $('.modal-footer .prev').html("");
        $('.modal-footer .next').html("");


        $('.modal-container .name h2').html(title);
        $('.modal-container .team-image img').attr('src', image);
        $('.modal-container .content').html(bio);

        if(related){
          $('.modal-container .involved').show();
          $('.modal-container .involved ul').html(related);
        } else {
          $('.modal-container .involved').hide();
        }

        // Prev Next
        if(!prevTitle){
          $('.left-meet').css('opacity', 0);
        } else {
          $('.left-meet').css('opacity', 1);
          $('.modal-footer .prev').html(prevTitle);
        }

        if(!nextTitle){
          $('.right-meet').css('opacity', 0);
        } else {
          $('.right-meet').css('opacity', 1);
          $('.modal-footer .next').html(nextTitle);
        }

        $('.modal-main').removeClass('change');

      }, 600);

    });

  $('.close-modal').click(function() {
    $('.modal-container').toggleClass('show-modal');
    $('.modal-content').toggleClass('show-modal-content');
    $('body').toggleClass('no-scroll');

    $('.modal-container .name h2').html("");
    $('.modal-container .name a').attr('href', "");
    $('.modal-container .content').html("");
    $('.modal-container .company-facts ul').html("");
    $('.modal-container .team-involved ul').html("");
    $('.modal-container .company-logo').attr('src', "");

    $('.modal-container .name h2').html("");
    $('.modal-container .team-image img').attr('src', "");
    $('.modal-container .content').html("bio");
    $('.modal-container .involved ul').html("");


  });

  $('.slider').slick({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
    autoplay: true,
  });

  $('.login').hover(function(){
    $('.investor-login').toggleClass('show-text');
  });

  var showDecimal = 0;

  $('.counters').waypoint({
      handler: function() {
        (function ($) {
        $.fn.countTo = function (options) {
          options = options || {};

          return $(this).each(function () {
            // set options for current element
            var settings = $.extend({}, $.fn.countTo.defaults, {
              from:            $(this).data('from'),
              to:              $(this).data('to'),
              speed:           $(this).data('speed'),
              refreshInterval: $(this).data('refresh-interval'),
              decimals:        $(this).data('decimal'),
            }, options);

            showDecimal = $(this).data('decimal');

            // how many times to update the value, and how much to increment the value on each update
            var loops = Math.ceil(settings.speed / settings.refreshInterval),
              increment = (settings.to - settings.from) / loops;

            // references & variables that will change with each update
            var self = this,
              $self = $(this),
              loopCount = 0,
              value = settings.from,
              data = $self.data('countTo') || {};

            $self.data('countTo', data);

            // if an existing interval can be found, clear it first
            if (data.interval) {
              clearInterval(data.interval);
            }
            data.interval = setInterval(updateTimer, settings.refreshInterval);

            // initialize the element with the starting value
            render(value);

            function updateTimer() {
              value += increment;
              loopCount++;

              render(value);

              if (typeof(settings.onUpdate) == 'function') {
                settings.onUpdate.call(self, value);
              }

              if (loopCount >= loops) {
                // remove the interval
                $self.removeData('countTo');
                clearInterval(data.interval);
                value = settings.to;

                if (typeof(settings.onComplete) == 'function') {
                  settings.onComplete.call(self, value);
                }
              }
            }

            function render(value) {
              var formattedValue = settings.formatter.call(self, value, settings);
              $self.html(formattedValue);
            }
          });
        };


        $.fn.countTo.defaults = {
          from: 0,               // the number the element should start at
          to: 0,                 // the number the element should end at
          speed: 1000,           // how long it should take to count between the target numbers
          refreshInterval: 100,  // how often the element should be updated
          decimals: showDecimal,           // the number of decimal places to show
          formatter: formatter,  // handler for formatting the value before rendering
          onUpdate: null,        // callback method for every time the element is updated
          onComplete: null,       // callback method for when the element finishes updating
        };

        function formatter(value, settings) {
          return value.toFixed(settings.decimals);
        }
        }(jQuery));

        jQuery(function ($) {
        // custom formatting example
        $('.count-number').data('countToOptions', {
        formatter: function (value, options) {
          return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
        },
        });

        // start all the timers
        $('.timer').each(count);

        function count(options) {
        var $this = $(this);
        options = $.extend({}, options || {}, $this.data('countToOptions') || {});
        $this.countTo(options);
        }
        });
      },
      offset: 500,
    });


  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js